// Copyright (c) 2016 Deere & Company

import PartRequests from '../../part-requests/shared/components/part-returns';

export default {
    component: PartRequests,
    name: 'PART_REQUESTS',
    path: 'part-requests'
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/part-requests.js